import { useContext } from 'react'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import {
  Group,
  createGroup as apiCreateGroup,
  updateGroup as apiUpdateGroup
} from '../../../../../services/group'
import { pages } from '../../../../../config/pages'

import { GroupFormContext } from '../context'

export function useGroup() {
  const { group, loading, setLoading, getGroupState, updateGroupState } =
    useContext(GroupFormContext)
  const navigate = useNavigate()

  function createGroup(data: Partial<Group>) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => apiCreateGroup(data))
      .then(data => updateGroupState(data))
      .then(() => {
        toast.info('Grupo cadastrado com sucesso')
        navigate(pages.groups.path)
      })
      .finally(() => setLoading(false))
  }

  function updateGroup(data: Partial<Group>) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => getGroupState())
      .then(group => apiUpdateGroup(group.id, data))
      .then(data => updateGroupState(data))
      .then(() => {
        toast.info('O grupo foi alterado')
        navigate(pages.groups.path)
      })
      .finally(() => setLoading(false))
  }

  return {
    group,
    loading,
    createGroup,
    updateGroup
  }
}
